import React from "react";

export const R = ({ children }) => {
const _children = typeof children === "string" ? children : children[0]
  const split = typeof _children === "string" && _children.split("®");
  return split && _children.search("®") >= 0 ? (
    <>
      {split[0]}
      <sup>®</sup>
      {split[1]}
    </>
  ) : children;
};